/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 30th 2022, 10:49:08 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APIMany2OneSelectFormInput, ConcreteAPIMany2OneSelectFormInputProps } from "ui-widgets";
import { APISERVICEPATHS } from "lib/api";
import { SigningIcon } from "theme/icons";
import { COLORSCHEME } from "theme/styles";
import { DigitalSignatureMethod } from "lib/schemas";

export const DigitalSignatureMethodMany2OnePicker = <PrimaryObject,>(
  props: ConcreteAPIMany2OneSelectFormInputProps<PrimaryObject, DigitalSignatureMethod>
) => {
  return (
    <APIMany2OneSelectFormInput<PrimaryObject, DigitalSignatureMethod>
      label={props.label ?? "Digital Signature Provider"}
      itemIdProperty="id"
      getOptionLabel={(option) => option.name}
      loadingText="Loading Signing Providers"
      apiServicePath={APISERVICEPATHS.digitalSignatureMethods}
      inputStartAdornment={<SigningIcon fill={COLORSCHEME.primary} width={20} height={20} />}
      {...props}
    />
  );
};
